import { Input } from 'antd';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import { FormField } from '../form-field';

export type PhoneFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = {
  name: TName;
  control: Control<TFieldValues>;
  label?: string;
  help?: string;
  required?: boolean;
  fieldSize?: 'default' | 'tall';
  /** External server-side error status — shown when no field-level validation error is present. */
  status?: 'error' | 'warning';
  autoFocus?: boolean;
  placeholder?: string;
};

export function PhoneField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  help,
  required,
  fieldSize = 'default',
  status: externalStatus,
  autoFocus,
  placeholder,
}: PhoneFieldProps<TFieldValues, TName>) {
  return (
    <FormField name={name} control={control} label={label} help={help} required={required}>
      {({ field, fieldState }) => (
        <Input
          id={name}
          autoFocus={autoFocus}
          size={fieldSize === 'tall' ? 'large' : 'middle'}
          status={fieldState.error ? 'error' : externalStatus}
          prefix={<span>+1</span>}
          placeholder={placeholder}
          inputMode="numeric"
          maxLength={10}
          value={field.value ?? ''}
          onChange={(event) => field.onChange(event.target.value.replace(/\D/g, '').slice(0, 10))}
          onBlur={field.onBlur}
          ref={field.ref}
        />
      )}
    </FormField>
  );
}
